import { render, staticRenderFns } from "./BehaviorSetting.vue?vue&type=template&id=66a22340"
import script from "./BehaviorSetting.vue?vue&type=script&lang=js"
export * from "./BehaviorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports